import {get} from 'lodash';
import x2js from 'x2js';
import {checkForError} from './responseHelper'
import {normaliseBooks} from './dataCleanupUtil'

const xmlToJson = new x2js();

function keyReplace (apiKey) {
    let result;
    switch (apiKey) {
        case 'ISBN':
            result = 'isbn'
            break;
        case 'BOOKID':
            result = 'bookId'
            break;
        case 'AUTHOR':
            result = 'author'
            break;
        case 'ANNOTATIONS':
            result = 'annotations'
            break;
        case 'TITLE':
            result = 'title'
            break;
        case 'SERIES_NAME':
            result = 'series'
            break;
        case 'GENRE_NAME':
            result = 'genre'
            break;
        case 'LEVEL_NAME':
            result = 'grade'
            break;
        default:
            result =  apiKey.toLowerCase();
            break;
    }
    return result;
}

/*export function parseJson (j) {
    const result = [];
    const rawResult = get(j, 'GSP.RES.R', [])

    const booksRaw = Array.isArray(rawResult) ?
        rawResult.map(b => b.MT) :
        [rawResult.MT];

    booksRaw.forEach(b => {
        const r = {};
        b.forEach(o => {
            r[keyReplace(o['_N'])] = o['_V']
        })
        if(r.isbn){
            result.push(r)
        }
    })

    return normaliseBooks(result);
}*/

function parseHtmlEntities(string) {
    var updatedString= string;
    if(updatedString.includes("&apos;s")){
     updatedString = updatedString.replaceAll("&apos;s", "\'s");
    }else{
        updatedString = updatedString.replaceAll("&apos;", "\'");
    }
    updatedString = updatedString.replaceAll("&amp;", "&");
    updatedString = updatedString.replaceAll("&quot;", "\"");
    updatedString = updatedString.replaceAll("&lt;","<");
    updatedString = updatedString.replaceAll("&gt;",">");
    return updatedString;
}

function convertStringToHtmlEntities(string) {
    var updatedString= string;
    updatedString = updatedString.replaceAll("&", "&amp;");
    if(updatedString.includes("\'s")){
     updatedString = updatedString.replaceAll("\'s", "&apos;s");
    }else{
        updatedString = updatedString.replaceAll("\'", "&apos;");
    }
    updatedString = updatedString.replaceAll("\"", "&quot;");
    updatedString = updatedString.replaceAll("<","&lt;");
    updatedString = updatedString.replaceAll(">","&gt;");
    return updatedString;
}

/*export function parseJson2 (j) {
    const result = [];
    //alert("print to consol " + j) ;
    //console.log(j);
    const rawResult = get(j, 'autnresponse.responsedata.hit', [])

    const booksRaw = Array.isArray(rawResult) ?
        rawResult.map(b => b.content.DOCUMENT) :
        [rawResult.content.DOCUMENT];

    booksRaw.forEach(b => {

        const r = {};
        var annotations = b['ANNOTATIONS'];
        var author = b['AUTHOR'];
        var title = b['TITLE'];
        var seriesName = b['SERIES_NAME'];
        r[keyReplace('ANNOTATIONS')] = parseHtmlEntities(annotations);
        r[keyReplace('AUTHOR')] = parseHtmlEntities(author);
        r[keyReplace('BOOK_ID')] = b['BOOK_ID'];
        r[keyReplace('CHALLENGE_YEAR')] = b['CHALLENGE_YEAR'];
        r[keyReplace('COMMENTS')] = b['COMMENTS'];
        r[keyReplace('DIFFICULT_READ_YN')] = b['DIFFICULT_READ_YN'];
        r[keyReplace('GENRE_NAME')] = b['GENRE_NAME'];
        r[keyReplace('IMAGE_PRESENT_YN')] = b['IMAGE_PRESENT_YN'];
        let isbn = b['ISBN'];
        const isbnArray = isbn.split(", ");
        r[keyReplace('ISBN')] = isbnArray[0];
        r[keyReplace('LEVEL_NAME')] = b['LEVEL_NAME'];
        r[keyReplace('SERIES_NAME')] = parseHtmlEntities(seriesName);
        r[keyReplace('TITLE')] = parseHtmlEntities(title);
        r[keyReplace('TYPE_NAME')] = b['TYPE_NAME'];
        r[keyReplace('YEAR_PUBLISHED')] = b['YEAR_PUBLISHED'];
        result.push(r);

    })

    return normaliseBooks(result);
}*/

/*export function parseElasticJson(json) {
    const hits = json?.hits?.hits || [];
    const books = hits.map(hit => {
        const src = hit._source;
        return {
            isbn: src.isbn,
            bookId: src.book_id,
            author: src.author,
            annotations: src.annotations,
            title: src.title,
            series: src.series_name,
            genre: src.genre_name,
            grade: src.level_name,
            comments: src.comments,
            typeName: src.type_name,
            year_published: src.year_published,
            challenge_year: src.challenge_year,
            image_present_yn: src.image_present_yn,
            difficult_read_yn: src.difficult_read_yn
        };
    });
    return normaliseBooks(books);
}*/

export function parseElasticJson(json) {
    const booksArray = json?.books || [];
    console.log("Books array size:", booksArray.length);
    const books = booksArray.map(src => {
        // Handle multiple ISBNs - take only the first one for image URL compatibility
        let isbn = src.isbn;
        if (isbn && isbn.includes(", ")) {
            const isbnArray = isbn.split(", ");
            isbn = isbnArray[0];
        }
        return {
            isbn: isbn,
            bookId: src.book_id,
            author: src.author,
            annotations: src.annotations,
            title: src.title,
            series: src.series_name,
            genre: src.genre_name,
            grade: src.level_name,
            comments: src.comments,
            type_name: src.type_name,
            year_published: src.year_published,
            challenge_year: src.challenge_year,
            image_present_yn: src.image_present_yn,
            difficult_read_yn: src.difficult_read_yn
        };
    });
    console.log("Normalised books size:", books.length);
    return normaliseBooks(books);
}


/*function fetchApi(body) {
    // add 'http://localhost:8080/' to url for calling api in local vpn environment
    const fetchPromise = (String(process.env.REACT_APP_MOCK_API) === 'true') ?
        import('./mock/sampleDataIDOL').then((module) => module.default) :
        fetch("/prcws/search", {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(body),
        });

    return fetchPromise
        // fetch doesn't reject the promise for HTTP error statuses, it returns ok = false
        .then(checkForError)
        .then(res => res.text())
        .then(xml => xmlToJson.xml2js(xml))
        .then(json => parseJson2(json))
        .catch((error) => {
            console.log('error', error)
        })
}*/

function fetchApi(body) {
    const fetchPromise = fetch("/prcws/search", {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body),
    });

    return fetchPromise
        .then(checkForError)
        .then(res => res.json())   // ️ No XML, directly JSON
        .then(json => parseElasticJson(json))
        .catch((error) => {
            console.log('error', error)
        });
}

export function discoveryFetch(options, limit = 1000) {
    return fetchApi({
        ...options,
        limit,
    });
}

export function searchFetch(keyword, limit = 200) {
    //var keyword1 = convertStringToHtmlEntities(keyword);
   // keyword = keyword1;
    return fetchApi({
        keyword,
        limit,
    });
}
